import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSendEmail = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.88586 10.685C3.63641 10.6146 3.41608 10.4662 3.25716 10.2615C3.09823 10.0567 3.00909 9.80644 3.0028 9.54733C2.99651 9.28823 3.07339 9.03392 3.22219 8.82171C3.37098 8.60949 3.58385 8.45053 3.82959 8.36814L20.1977 3.02981C20.3049 2.99486 20.4197 2.99019 20.5294 3.01632C20.6391 3.04245 20.7395 3.09836 20.8194 3.17789C20.8994 3.25743 20.9558 3.35749 20.9825 3.46706C21.0092 3.57662 21.0052 3.69144 20.9708 3.79884L15.6365 20.1751C15.5545 20.4212 15.3956 20.6346 15.1833 20.7837C14.971 20.9328 14.7164 21.0098 14.457 21.0034C14.1976 20.9971 13.9471 20.9076 13.7424 20.7482C13.5376 20.5888 13.3895 20.3679 13.3197 20.118L11.488 12.5085L3.88586 10.685Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8199 3.17656L11.488 12.5084"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgSendEmail.displayName = 'SvgSendEmail';
export default SvgSendEmail;
